import {
  FieldType,
  makeScalarField,
  buildSchema,
  defaultValueForFields,
} from "@react-typed-forms/schemas";

export interface ApplicationForm {
  name: string;
  dateOfBirth: string;
  occupation: string;
  email: string;
  mobile: string;
  nominator: string;
  nominatorSignature: string[];
  seconder: string;
  seconderSignature: string[];
}

export const ApplicationFormSchema = buildSchema<ApplicationForm>({
  name: makeScalarField({
    type: FieldType.String,
    notNullable: true,
    required: true,
    displayName: "Name",
  }),
  dateOfBirth: makeScalarField({
    type: FieldType.Date,
    notNullable: true,
    required: true,
    displayName: "Date Of Birth",
  }),
  occupation: makeScalarField({
    type: FieldType.String,
    notNullable: true,
    required: true,
    displayName: "Occupation",
  }),
  email: makeScalarField({
    type: FieldType.String,
    notNullable: true,
    required: true,
    displayName: "Email",
  }),
  mobile: makeScalarField({
    type: FieldType.String,
    notNullable: true,
    required: true,
    displayName: "Mobile",
  }),
  nominator: makeScalarField({
    type: FieldType.String,
    notNullable: true,
    required: true,
    displayName: "Nominator",
  }),
  nominatorSignature: makeScalarField({
    type: FieldType.String,
    collection: true,
    notNullable: true,
    displayName: "Nominator Signature",
  }),
  seconder: makeScalarField({
    type: FieldType.String,
    notNullable: true,
    required: true,
    displayName: "Seconder",
  }),
  seconderSignature: makeScalarField({
    type: FieldType.String,
    collection: true,
    notNullable: true,
    displayName: "Seconder Signature",
  }),
});

export const defaultApplicationForm: ApplicationForm = defaultValueForFields(
  ApplicationFormSchema,
);

export const SchemaMap = {
  ApplicationForm: ApplicationFormSchema,
};
